<template>
<div class="chapter">
<div class="inner_page">
<p class="toc">I<span class="small">NTRODUCTION</span></p>
<p class="noindent">If you want to learn about real-life heroes and villains of Long Island’s South Shore, then this is the book for you. Inside are the true stories of pirates; George Washington’s spy chief, Benjamin Tallmadge; U.S. Navy captain David Porter; and Herman Melville.</p>
<p class="indent">You will read about some of the most devastating of the hundreds of shipwrecks along Fire Island’s shores and the nearly unbelievable rescue attempts of passengers and crew by local heroes.</p>
<p class="indent">If mystery is what you’re looking for, then you need look no further than the story of the Mystery of Old Inlet. For two centuries, men and women have studied the case of the eleven strong and healthy young men who went to sea on a beautiful Friday afternoon to go fishing and never returned. What destroyed their boat and killed them all on a warm calm late fall evening only a few hundred yards from shore?</p>
<p class="indent">Have you ever wondered what created Fire Island and where it got its name? Were the Irish the first to visit, or was it the ancient Norse who explored the east coast? What about Basque and other western European fishermen; did they precede Columbus?</p>
<p class="indent">You will discover the almost forgotten contributions of World War I navy men at the Bay Shore Naval Air Station and at West Sayville’s Section Base 5 and learn about the heroic things they did in America’s effort to win the “war to end all wars.”</p>
<p class="indent">You will discover secrets that the Native Americans taught the earliest South Shore settlers about catching whales and what Herman Melville experienced that enabled him to write his most famous work, <i>Moby Dick</i>.</p>
<p class="indent">Finally, you will enjoy the remarkable story of how and why Santa Claus came to fly around the Fire Island Lighthouse.</p>
<p class="image"><img alt="image" src="images/pg14.jpg"/></p>
<p class="src">Reference points on Long Island, Fire Island and the Great South Bay. <i>Map courtesy of Elaine Kiesling Whitehouse</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?e0b4e894